<div class="min-w-[320px]">
  <div
    class="flex items-center gap-2 justify-start text-lg font-semibold p-8 pb-2"
  >
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>
      {{
        'COMMON.ABOUT_RECORD_TITLE'
          | transloco
            : {
                entityLabel:
                  data.entityLabel ?? ('COMMON.RECORD_LABEL' | transloco),
              }
      }}
    </span>
  </div>

  <mat-dialog-content class="flex flex-col gap-6">
    <section class="px-4 py-3 border-b border-slate-200">
      <div class="grid grid-cols-2 gap-x-8 gap-y-2">
        @for (field of this.baseAuditFields; track field.label) {
          <div class="flex flex-col gap-1 text-sm">
            <span class="font-medium text-slate-500">
              {{ field.label | transloco }}
            </span>
            @if (field.value === 'id') {
              <span
                class="min-w-0 break-words font-medium text-gray-900 font-mono"
              >
                {{ getFieldValue(field.value) }}
              </span>
            } @else if (
              field.value === 'createdBy' || field.value === 'updatedBy'
            ) {
              <span class="min-w-0 break-words font-medium text-gray-900">
                {{ getUserDisplayName(getFieldValue(field.value)) }}
              </span>
            } @else if (
              field.value === 'createdAt' || field.value === 'lastUpdatedAt'
            ) {
              <span class="min-w-0 break-words font-medium text-gray-900">
                {{
                  (
                    getFieldValue(field.value)
                    | translocoDate: { dateStyle: 'short', timeStyle: 'short' }
                  ).replace(',', '')
                }}
              </span>
            }
          </div>
        }
      </div>
    </section>

    @if (tableFields().length > 0) {
      <section class="px-4 py-3">
        <div class="grid grid-cols-2 gap-x-8 gap-y-2">
          @for (field of this.tableFields(); track field.label) {
            <div class="flex flex-col gap-1 text-sm">
              <span class="font-medium text-slate-500">
                {{ field.label | transloco }}
              </span>
              @let column = getColumnForField(field.value);
              @let value = getFieldValue(field.value);

              @if (value === undefined || value === null || value === '') {
                <span class="min-w-0 break-words font-medium text-gray-900"
                  >—</span
                >
              } @else if (column && column.type === TableColumnType.OBJECT) {
                <span class="min-w-0 break-words font-medium text-gray-900">{{
                  column.mappingFn(value)
                }}</span>
              } @else if (column && column.type === TableColumnType.DATE) {
                <span class="min-w-0 break-words font-medium text-gray-900">{{
                  value | translocoDate
                }}</span>
              } @else if (column && column.type === TableColumnType.DATE_TIME) {
                <span class="min-w-0 break-words font-medium text-gray-900">{{
                  (
                    value
                    | translocoDate: { dateStyle: 'short', timeStyle: 'short' }
                  ).replace(',', '')
                }}</span>
              } @else if (
                column && column.type === TableColumnType.VALUE_WITH_CURRENCY
              ) {
                <span class="min-w-0 break-words font-medium text-gray-900">{{
                  value | translocoCurrency: 'symbol' : {} : getCurrencyCode()
                }}</span>
              } @else if (
                column && column.type === TableColumnType.VALUE_WITH_PERCENTAGE
              ) {
                <span class="min-w-0 break-words font-medium text-gray-900">
                  {{
                    column.internationalize
                      ? value
                        ? (value / 100.0
                          | translocoPercent
                            : { minimumFractionDigits: column.digits })
                        : ''
                      : value
                  }}
                </span>
              } @else if (column && column.type === TableColumnType.DECIMAL) {
                <span class="min-w-0 break-words font-medium text-gray-900">
                  {{
                    column.internationalize
                      ? value
                        ? (value
                          | translocoDecimal
                            : { minimumFractionDigits: column.digits })
                        : ''
                      : value
                  }}
                </span>
              } @else if (column && column.type === TableColumnType.NUMBER) {
                <span class="min-w-0 break-words font-medium text-gray-900">
                  {{
                    column.internationalize && value !== 0
                      ? value
                        ? (value | translocoDecimal)
                        : ''
                      : value
                  }}
                </span>
              } @else {
                <span class="min-w-0 break-words font-medium text-gray-900">{{
                  value
                }}</span>
              }
            </div>
          }
        </div>
      </section>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="mt-4">
    <app-button-generator
      text="COMMON.CLOSE"
      [variant]="ButtonVariant.PRIMARY"
      (function)="dialogRef.close()"
    />
  </mat-dialog-actions>
</div>
